import * as React from 'react';
import { Group, Text, useMantineTheme, createStyles, ActionIcon } from "@mantine/core";
import { IconUpload, IconX, IconPhoto, IconTrash } from "@tabler/icons-react";
import { Dropzone, FileWithPath } from "@mantine/dropzone";
import { useElementSize } from "@mantine/hooks";
import useStore from "../../store";

type UploadType = 'image' | 'file';

interface FileUploadProps {
    value?: string | FileWithPath | null;
    onChange: (value: FileWithPath | null) => void;
    label?: string;
    accept?: string[];
    type?: UploadType;
    ratio?: `${number}/${number}`
}

const useStyles = createStyles((theme) => {
    return {
        value: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            border: `1px solid ${theme.colors.gray[3]}`,
            borderRadius: 6,
            marginTop: '1rem',
            padding: '1rem .3rem'
        },
        image: {
            width: '100%',
            objectFit: 'fill',
        },
        anchor: {
            display: 'block',
            width: '100%',
            textAlign: 'center'
        }
    }
})

const FileUpload = ({
    value = null,
    onChange,
    label,
    accept,
    type = 'image',
    ratio
}: FileUploadProps) => {
    const theme = useMantineTheme();
    const { classes } = useStyles();
    const { ref, width, height } = useElementSize();
    const token = useStore(state => state.auth.token);
    const renderPreview = () => {
        if (!value) {
            return null;
        }
        if (type === 'image') {
            const imageUrl = typeof value !== 'string' ?  URL.createObjectURL(value) : value;
            if (ratio) {
                const [ horizontal, vertical ] = ratio.split('/').map(number => Number(number));
                const containerHeight = width / (horizontal / vertical);
                return (
                    <div style={{ height: containerHeight || undefined, overflow: 'hidden', marginTop: '1rem' }}>
                        <img
                            src={imageUrl}
                            onLoad={(img) => {
                                URL.revokeObjectURL(imageUrl)
                                const { naturalWidth, naturalHeight, height } = img.currentTarget
                                if (containerHeight > height) {
                                    img.currentTarget.height = containerHeight;
                                }
                            }}
                            className={classes.image}
                            height={undefined}
                            alt=''
                        />
                    </div>
                )
            }
            return (
                <img
                    src={imageUrl}
                    onLoad={() => URL.revokeObjectURL(imageUrl)}
                    className={classes.image}
                    // height={height || undefined}
                    alt=''
                    style={{ marginTop: '1rem' }}
                />
            )
        }
        if (typeof value === 'string') {
            const redirectURL = `${value}?Policy=${token}`;
            return (
                <div className={classes.value}>
                    <ActionIcon color={'red'} onClick={() => onChange(null)}>
                        <IconTrash size={18}/>
                    </ActionIcon>
                    <a className={classes.anchor} href={redirectURL} target='_blank' rel='noreferrer nofollow noopener '>Харах</a>
                </div>
            );
        }
        return (
            <div className={classes.value}>
                {value.name}
            </div>
        )
    }

    return (
        <div>
            <Text size={14}>
                {label}
            </Text>
            <Dropzone
                onDrop={(value) => {
                    onChange(value?.[0] ?? null);
                }}
                accept={accept}
                multiple={false}
            >
                <Group position="center" spacing="xl" style={{ minHeight: '2rem', pointerEvents: 'none' }}>
                    <Dropzone.Accept>
                        <IconUpload
                            size="3.2rem"
                            stroke={1.5}
                            color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
                        />
                    </Dropzone.Accept>
                    <Dropzone.Reject>
                        <IconX
                            size="3.2rem"
                            stroke={1.5}
                            color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
                        />
                    </Dropzone.Reject>
                    <Dropzone.Idle>
                        {
                            type === 'image'
                            ?   <IconPhoto size="3.2rem" stroke={1.5} />
                            :   <IconUpload size="2rem" stroke={1.5} />
                        }
                    </Dropzone.Idle>
                    <Text size="md">
                        ХУУЛАХ
                    </Text>
                </Group>
            </Dropzone>
            <div ref={ref}>
                {renderPreview()}
            </div>
        </div>
    )
}

export default FileUpload;